/**
 * Sticky Add-to-Cart — mirrors the original ATC button when it scrolls
 * out of view. Submission is delegated to the original <form> via the
 * sticky button's `form="..."` attribute, so all variant/quantity logic
 * stays in the existing product form.
 */
(function () {
  if (typeof window === 'undefined') return;

  function init() {
    var section = document.querySelector('.main-product-section, .main-product[data-section-id]');
    if (!section) return;

    var sticky = document.querySelector('.haut-sticky-atc');
    if (!sticky) return;

    var originalBtn = section.querySelector('.product-form__submit');
    var originalPrice = section.querySelector('.main-product-price-org, [id^="price-"]');
    var stickyBtn = sticky.querySelector('.haut-sticky-atc__button');
    var stickyPrice = sticky.querySelector('.haut-sticky-atc__price');

    if (!originalBtn) return;

    // 1) Show/hide sticky based on original ATC visibility.
    //    Also toggle body.haut-sticky-active so we can lift Smile.io / Wizybot
    //    launchers above the sticky bar via CSS.
    function setActive(isActive) {
      sticky.classList.toggle('haut-sticky-atc--visible', isActive);
      document.body.classList.toggle('haut-sticky-active', isActive);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setActive(!entry.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '0px 0px -10px 0px' });
      io.observe(originalBtn);
    } else {
      // Fallback for very old browsers
      setActive(true);
    }

    // 2) Mirror price changes from the original price block
    if (originalPrice && stickyPrice) {
      stickyPrice.innerHTML = originalPrice.innerHTML;
      var priceObserver = new MutationObserver(function () {
        stickyPrice.innerHTML = originalPrice.innerHTML;
      });
      priceObserver.observe(originalPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // 3) Mirror disabled/sold-out state and label
    function syncButton() {
      if (!stickyBtn) return;
      var disabled = originalBtn.hasAttribute('disabled');
      var label = (originalBtn.textContent || '').trim();
      stickyBtn.disabled = disabled;
      if (label) stickyBtn.textContent = label;
    }
    syncButton();
    var btnObserver = new MutationObserver(syncButton);
    btnObserver.observe(originalBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });

    // 4) Track click for analytics (datalayer push for GTM)
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'sticky_atc_click',
            location: 'sticky_bar',
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
